import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import buttonClasses from './Button.module.scss';

export default function Button({
  variant = 'normal',
  color = 'primary',
  type = 'button',
  minimal = false,
  pointer = false,
  className,
  fullWidth,
  onClick,
  children,
  prefix,
  suffix,
  disabled,
}) {
  const cs = cx(
    minimal ? buttonClasses.minimal : buttonClasses.button,
    {
      [buttonClasses[`variant-${variant}`]]: variant !== undefined,
      [buttonClasses[`color-${color}`]]: color !== undefined,
      [buttonClasses[`full-width`]]: fullWidth,
      [buttonClasses.pointer]: pointer,
    },
    disabled && 'disabled',
    className,
  );

  return (
    <button type={type} onClick={onClick} className={cs} disabled={disabled}>
      {prefix}
      {children && <span>{children}</span>}
      {suffix}
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['normal', 'raised', 'outline', 'flat']),
  type: PropTypes.oneOf(['button', 'submit']),
  color: PropTypes.oneOf([
    'primary',
    'font-primary',
    'secondary',
    'accent',
    'warning',
    'error',
    'white',
  ]),
  children: PropTypes.node,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  minimal: PropTypes.bool,
  pointer: PropTypes.bool,
  disabled: PropTypes.bool,
};
